export default {
  BROWSE: 'browse',
  FETCHING: 'fetching',
  WITH_ERROR: 'with_error',
  WITH_RESULTS: 'with_results',
};
